import { Col } from '../grid';
export default Col;


//////////////////
// WEBPACK FOOTER
// /Users/ddcat/project/ant-design-pro-site/ant-design-pro-site/scaffold/node_modules/antd/es/col/index.js
// module id = 551
// module chunks = 0